export const isApiTrue = (v) => v === true || v === 1 || v === "1";
